import styled from 'styled-components';
export var Graph = styled.div.withConfig({
  displayName: "Graph",
  componentId: "sc-yb01u4-0"
})(["position:absolute;z-index:10;top:0;bottom:0;left:0;right:0;color:", ";pointer-events:none;svg{width:100%;height:100%;}"], function (_ref) {
  var theme = _ref.theme,
    up = _ref.up;
  return up ? theme.colors.positive : theme.colors.negative;
});